import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeUrgent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2169 16.2867V21.4915L26.3398 23.5734",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0718 11.5721C15.1889 11.4839 15.318 11.4231 15.4516 11.3885L15.4495 11.3901L15.4429 11.395L15.4363 11.4L15.4298 11.4049L15.4232 11.4099L15.4166 11.4149L15.41 11.4198L15.4034 11.4248L15.3968 11.4298L15.3902 11.4348L15.3836 11.4398L15.3769 11.4448L15.3703 11.4498L15.3637 11.4548L15.357 11.4598L15.3504 11.4648L15.3437 11.4698L15.3371 11.4748L15.3304 11.4798L15.3238 11.4848L15.3171 11.4898L15.3104 11.4949L15.3038 11.4999L15.2971 11.5049L15.2904 11.51L15.2837 11.515L15.277 11.5201L15.2703 11.5251L15.2636 11.5302L15.2569 11.5352L15.2502 11.5403L15.2435 11.5453L15.2367 11.5504L15.23 11.5555L15.2233 11.5605L15.2165 11.5656L15.2098 11.5707L15.203 11.5758L15.1963 11.5809L15.1895 11.586L15.1828 11.5911L15.176 11.5962L15.1692 11.6013L15.1625 11.6064L15.1557 11.6115L15.1489 11.6166L15.1421 11.6217L15.1353 11.6268L15.1285 11.6319L15.1217 11.6371L15.1149 11.6422L15.1081 11.6473L15.1013 11.6525L15.0945 11.6576L15.0877 11.6627L15.0808 11.6679L15.074 11.673L15.0672 11.6782L15.0603 11.6833L15.0535 11.6885L15.0467 11.6936L15.0398 11.6988L15.0329 11.704L15.0261 11.7091L15.0192 11.7143L15.0124 11.7195L15.0055 11.7247L14.9986 11.7298L14.9917 11.735L14.9848 11.7402L14.978 11.7454L14.9711 11.7506L14.9642 11.7558L14.9573 11.761L14.9504 11.7662L14.9435 11.7714L14.9366 11.7766L14.9296 11.7818L14.9227 11.787L14.9158 11.7922L14.9089 11.7975L14.9019 11.8027L14.895 11.8079L14.8881 11.8131L14.8811 11.8184L14.8742 11.8236L14.8672 11.8288L14.8603 11.8341L14.8533 11.8393L14.8464 11.8446L14.8394 11.8498L14.8324 11.8551L14.8255 11.8603L14.8185 11.8656L14.8115 11.8708L14.8045 11.8761L14.7976 11.8813L14.7907 11.8865C14.8607 11.7676 14.9548 11.6603 15.0718 11.5721Z",
			fill: "#007AFF",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.7354 11.5721C30.6184 11.4839 30.4893 11.4231 30.3557 11.3885L30.3578 11.3901L30.3643 11.395L30.3709 11.4L30.3775 11.4049L30.3841 11.4099L30.3907 11.4149L30.3973 11.4198L30.4039 11.4248L30.4105 11.4298L30.4171 11.4348L30.4237 11.4398L30.4303 11.4448L30.4369 11.4498L30.4436 11.4548L30.4502 11.4598L30.4569 11.4648L30.4635 11.4698L30.4702 11.4748L30.4768 11.4798L30.4835 11.4848L30.4901 11.4898L30.4968 11.4949L30.5035 11.4999L30.5102 11.5049L30.5169 11.51L30.5235 11.515L30.5302 11.5201L30.5369 11.5251L30.5436 11.5302L30.5504 11.5352L30.5571 11.5403L30.5638 11.5453L30.5705 11.5504L30.5772 11.5555L30.584 11.5605L30.5907 11.5656L30.5975 11.5707L30.6042 11.5758L30.611 11.5809L30.6177 11.586L30.6245 11.5911L30.6312 11.5962L30.638 11.6013L30.6448 11.6064L30.6516 11.6115L30.6583 11.6166L30.6651 11.6217L30.6719 11.6268L30.6787 11.6319L30.6855 11.6371L30.6923 11.6422L30.6991 11.6473L30.7059 11.6525L30.7128 11.6576L30.7196 11.6627L30.7264 11.6679L30.7332 11.673L30.7401 11.6782L30.7469 11.6833L30.7538 11.6885L30.7606 11.6936L30.7674 11.6988L30.7743 11.704L30.7812 11.7091L30.788 11.7143L30.7949 11.7195L30.8018 11.7247L30.8086 11.7298L30.8155 11.735L30.8224 11.7402L30.8293 11.7454L30.8362 11.7506L30.8431 11.7558L30.85 11.761L30.8569 11.7662L30.8638 11.7714L30.8707 11.7766L30.8776 11.7818L30.8845 11.787L30.8914 11.7922L30.8984 11.7975L30.9053 11.8027L30.9122 11.8079L30.9192 11.8131L30.9261 11.8184L30.9331 11.8236L30.94 11.8288L30.947 11.8341L30.9539 11.8393L30.9609 11.8446L30.9678 11.8498L30.9748 11.8551L30.9818 11.8603L30.9887 11.8656L30.9957 11.8708L31.0027 11.8761L31.0097 11.8813L31.0165 11.8865C30.9465 11.7676 30.8525 11.6603 30.7354 11.5721Z",
			fill: "#007AFF",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.2167 30.8602C28.3909 30.8602 32.5854 26.6657 32.5854 21.4916C32.5854 16.3174 28.3909 12.1229 23.2167 12.1229C18.0426 12.1229 13.8481 16.3174 13.8481 21.4916C13.8481 26.6657 18.0426 30.8602 23.2167 30.8602Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0939 9H26.3396",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2169 9V12.1229",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.31821 18H11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.30209 22H10",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "bevel"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.34343 26H11",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "bevel"
		})
	]
});
const ForwardRef = forwardRef(SvgTimeUrgent);
export default ForwardRef;
